import React from 'react'
import './MultiCursor.scss';

const MultiCursor = () => {
  return (
    <div className="multiCursor">
      <div className="line line1">
        <div className="widget widget1">Ritik</div>
      </div>
      <div className="line line2">
        <div className="widget widget2">Vivek</div>
      </div>
      <div className="line line3">
        <div className="widget widget3">Kush</div>
      </div>
      <div className="line line4">
        <div className="widget widget4">Jatin</div>
      </div>
      <div className="line line5">
        <div className="widget widget5">Vivek</div>
      </div>
    </div>
  )
}

export default MultiCursor